import { Alert as UnstyledAlert, styled } from "@mui/material";

import { TextField as UnstyledTextField } from "#src/components/form";

export const Alert = styled(UnstyledAlert)(({ theme }) => ({
  margin: theme.spacing(1.5, 0),
}));

export const DescriptionField = styled(UnstyledTextField)({
  "&.MuiFormControl-root": {
    marginBottom: 0,
  },
}) as typeof UnstyledTextField;
